// Sprint 0078 — Maintenance auto-assignment rules API client.
import apiClient from '@/shared/api/client'

export interface AssignmentRule {
  id: string
  machine_type: string
  department_id: string | null
  primary_user_id: string
  backup_user_id: string | null
  notes: string | null
  is_active: boolean
  created_at: string
  updated_at: string
}

export interface CreateRuleBody {
  machine_type: string
  department_id?: string | null
  primary_user_id: string
  backup_user_id?: string | null
  notes?: string | null
}

export interface UpdateRuleBody {
  primary_user_id?: string
  backup_user_id?: string | null
  notes?: string | null
  is_active?: boolean
}

export const assignmentRulesApi = {
  list: async (params?: {
    machine_type?: string
    department_id?: string
    include_inactive?: boolean
  }) => {
    const r = await apiClient.get<AssignmentRule[]>('/maintenance/assignment-rules', { params })
    return r.data
  },

  create: async (body: CreateRuleBody) => {
    const r = await apiClient.post<AssignmentRule>('/maintenance/assignment-rules', body)
    return r.data
  },

  update: async (id: string, body: UpdateRuleBody) => {
    const r = await apiClient.patch<AssignmentRule>(`/maintenance/assignment-rules/${id}`, body)
    return r.data
  },

  delete: async (id: string) => {
    await apiClient.delete(`/maintenance/assignment-rules/${id}`)
  },
}
